import { useContext } from 'react';
import { BackendDispatchContext } from '../context/backend-context';
import { useCreateEntity } from './use-create-entity';

export const useCreateTicketMessage = (ticketId: string) => {
  const { asyncActions } = useContext(BackendDispatchContext)
  return useCreateEntity(asyncActions!.createTicketMessage.bind(asyncActions));
}